import './TopLogo.css';

function TopLogo({ text }) {
    return (
        <svg
            className="top-logo"
            width="100%"
            height="55"
            style={{ overflow: 'visible', display: 'block' }}
        >
            <text x="50%" y="50%" textAnchor="middle" dominantBaseline="central">
                {text}
            </text>
        </svg>
    );
}
export default TopLogo;
